<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

@if ((currentStep$ | async) !== ConfirmationSteps.SET_SPIN) {
  <p-button-pure
    icon="close"
    [aria]="{ 'aria-haspopup': 'dialog' }"
    (click)="showCancelActivationModal()"
    class="mt-fluid-lg md:mt-fluid-md"
  >
    @if ((type$ | async) !== 'VEHICLE' && (type$ | async) !== 'SECONDARY_VEHICLE') {
      {{ 'signup.activateAccount.cancelActivation.button.label' | translate }}
    } @else {
      {{ 'pida.addVehicle.confirmationCode.btnCancelActivation' | translate }}
    }
  </p-button-pure>
}

<p-modal [open]="showModal" (dismiss)="toggleModal('close')">
  <p-heading [slot]="'header'" size="lg" [tag]="'h2'">{{ modalHeader | translate }}</p-heading>
  @if ((type$ | async) !== 'VEHICLE' && (type$ | async) !== 'SECONDARY_VEHICLE') {
    <p-text>
      {{ 'signup.activateAccount.cancelActivation.modal.body' | translate }}
    </p-text>
    <div class="flex flex-col gap-y-fluid-sm sm:flex-row sm:gap-x-static-sm mt-fluid-md">
      <p-button (click)="cancelActivation()">
        {{ 'signup.activateAccount.cancelActivation.modal.button.cancel' | translate }}
      </p-button>
      <p-button [variant]="'secondary'" (click)="toggleModal('continue_activation')">
        {{ 'signup.activateAccount.cancelActivation.modal.button.continue' | translate }}
      </p-button>
    </div>
  } @else {
    <p-text>
      {{ 'pida.addVehicle.cancelActivation.modal.body' | translate }}
    </p-text>
    <div class="flex flex-col gap-y-sm sm:flex-row sm:gap-x-sm mt-fluid-md">
      <p-button (click)="cancelActivation()">
        {{ 'pida.addVehicle.confirmationCode.btnCancelActivation' | translate }}
      </p-button>
      <p-button [variant]="'secondary'" (click)="toggleModal('continue_activation')">
        {{ 'pida.addVehicle.confirmationCode.btnResumeActivation' | translate }}
      </p-button>
    </div>
  }
</p-modal>
